

























































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import ExpansionPanel from "../ui/ExpansionPanel.vue";
import MonthPicker from "../ui/MonthPicker.vue";
import { ReportsModule } from "@/store/reports.module";
import FormValidator from "@/mixins/FormValidator";
import { ReportAction } from "~/services/report";
import { ContractsModule } from "@/store/contracts.module";
import PayDialog from "./PayForm.vue";
import moment from "moment";

@Component({
  components: { ExpansionPanel, MonthPicker, PayDialog },
})
export default class SingleParamReportPay extends Mixins(FormValidator) {
  @Prop()
  readonly title: string;
  @Prop({ default: false })
  readonly isDefault: boolean;
  @Prop({ required: true })
  readonly path: string;

  from = "";
  to = "";
  max = "";
  // min = ???  минимальный период формирования не указан в эпике. Уточнить у Олеси.

  formRef = "form";

  async openPay() {
    this.loaded = true;
    await ContractsModule.getPayDetail({
      contractRid: Number.parseInt(this.$route.params.id),
      date: this.to,
    }).then(() => {
      this.loaded = false;
      if (
        ContractsModule.payDetail &&
        ContractsModule.payDetail.sum_pay &&
        ContractsModule.payDetail.sum_pay != 0
      ) {
        ContractsModule.setShowPayDialog(true);
      } else this.dialogShow = true;
    });
  }

  async mounted() {
    await ContractsModule.getCurPeriod(this.$route.params.id);
    this.to = moment().format("YYYY-MM");
    this.max = moment().format("YYYY-MM-DD");
  }

  payDisable: boolean = true;
  loaded: boolean = false;
  dialogShow: boolean = false;

  @Watch("to") changeTo() {
    if (ContractsModule.curPeriod) {
      const curPeriod = ContractsModule.curPeriod;
      this.payDisable = this.to != curPeriod.cur_period;
    }
  }

  async generate(action: ReportAction) {
    if (!this.validateForm()) return;
    await ReportsModule.generateReport({
      action: action,
      path: this.path,
      type: "pdf",
      filename: this.title,
      query: {
        iContractId: this.$route.params.id,
        dtDate: this.to.replace("-", "") + "01",
      },
    });
  }
}
